import React from "react";
import Headers from "../components/Header";
import Footer from "../Screen/Footer";

const PrivacyPolicy = () => {
  return (
    <div>
      <Headers />
      <section className="container">
        <h2 className="mb-3">Privacy Policy</h2>
        <h3 className="mb-3">Introduction</h3>
        <p>
          This Privacy Policy describes how Blaccdot and its affiliates
          (collectively "Blaccdot", "we", "our", "us") collect, use, share,
          protect, and otherwise process your personal data through our website
          https://blaccdot.ae (hereinafter referred to as the "Platform").
        </p>
        <p>
          Blaccdot operates as a real estate lead generation service in the
          United Arab Emirates, connecting prospective property buyers, sellers,
          tenants, and investors with licensed real estate brokers, developers,
          and agencies operating in the UAE.
        </p>
        <p>
          By visiting this Platform, submitting your information, or using any
          service offered on the Platform, you expressly agree to be bound by
          this Privacy Policy and our Terms of Use. This Platform and its
          services are governed by the laws of the United Arab Emirates,
          including the{" "}
          <span style={{ fontWeight: "bold" }}>
            Federal Decree-Law No. 45 of 2021 on the Protection of Personal Data
            (PDPL)
          </span>{" "}
          and any regulations issued thereunder. If you do not agree, please do
          not use or access our Platform.
        </p>
        <p>
          Your personal data will primarily be stored and processed in the
          United Arab Emirates.
        </p>
        {/* <p>
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>
            What Personal Data We Collect
          </span>{" "}
        </p> */}
        <h3 className="mb-3">What Personal Data We Collect</h3>
        <p>
          We collect personal data that you voluntarily provide when interacting
          with our Platform or enquiring about real estate services. This
          includes:
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>
            Contact and Identity Information
          </span>{" "}
          such as your full name, email address, mobile number, and nationality.
          This is collected when you submit an enquiry form, register on the
          Platform, or contact us directly.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Property Preference Data</span>{" "}
          such as your preferred location, property type (apartment, villa,
          townhouse, commercial, etc.), budget range, purpose of purchase or
          lease (end use, investment, rental), preferred payment method (cash,
          mortgage), and timeline for transaction. This helps us match you with
          relevant real estate partners.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>
            Financial Indicative Information
          </span>{" "}
          such as your general budget range or whether you are seeking mortgage
          pre-approval. We do not collect full bank account details, card
          numbers, or any payment instrument information as no financial
          transactions are processed directly on this Platform.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Communication Data</span> such as
          records of your enquiries, messages, and interactions with us or our
          real estate partners through the Platform, phone, email, or messaging
          applications.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Behavioural and Usage Data</span>{" "}
          such as pages visited, listings viewed, search filters used, time
          spent on the Platform, device type, IP address, and browser
          information. This is collected automatically to improve Platform
          performance and relevance of listings shown to you.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Referral and Source Data</span>{" "}
          such as how you arrived at the Platform, including through digital
          advertising, social media, or third-party referral sources.
        </p>
        <p>
          You may browse certain sections of the Platform without providing
          personal data. However, submitting an enquiry or requesting to be
          connected to a real estate professional requires the provision of
          contact and preference information.
        </p>
        {/* <p>
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>
            How We Use Your Personal Data
          </span>{" "}
        </p> */}
         <h3 className="mb-3">How We Use Your Personal Data</h3>
        <p>We use your personal data for the following purposes:</p>
        <p>
          To process your property enquiry and connect you with relevant
          licensed real estate brokers, developers, or agencies in the UAE who
          match your stated preferences. To facilitate follow-up communication
          between you and our real estate partners on your behalf. To send you
          relevant property listings, market updates, new project launches, and
          promotional offers related to UAE real estate, subject to your consent
          and applicable UAE marketing regulations. To improve the relevance and
          personalisation of content and listings shown to you on the Platform.
          To analyse Platform usage, conduct research, and improve our lead
          generation and matching services. To verify the legitimacy of
          enquiries and prevent fraudulent or spam submissions. To comply with
          our legal obligations under UAE law, including regulations set by the{" "}
          <span style={{ fontWeight: "bold" }}>
            Real Estate Regulatory Agency (RERA)
          </span>{" "}
          and the{" "}
          <span style={{ fontWeight: "bold" }}>
            Dubai Land Department (DLD)
          </span>{" "}
          where applicable. To enforce our Terms of Use and protect the rights
          and safety of our users and partners.
        </p>
        {/* <p>
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>
            Sharing of Personal Data
          </span>
        </p> */}
         <h3 className="mb-3">Sharing of Personal Data</h3>
        <p>
          The core nature of our service involves sharing your enquiry data with
          relevant real estate professionals. By submitting an enquiry on our
          Platform, you explicitly consent to the following:
        </p>
        <p>
          {" "}
          <span style={{ fontWeight: "bold" }}>
            With Real Estate Partners:
          </span>{" "}
          Your name, contact number, email address, and property preferences
          will be shared with licensed real estate brokers, developers, and
          agencies in the UAE who are relevant to your enquiry. These partners
          will contact you directly to assist with your property search or
          transaction. You are encouraged to review their individual privacy
          policies.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>
            With Marketing and Technology Partners:
          </span>{" "}
          We may share aggregated or pseudonymised data with our advertising
          platforms, CRM providers, and analytics partners to improve lead
          quality and Platform performance. These partners are contractually
          bound to use your data only for the purposes we specify.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>
            With Regulatory and Government Authorities:
          </span>{" "}
          We may disclose your personal data to UAE government agencies, RERA,
          DLD, law enforcement authorities, or courts when required by law, or
          when we have a good faith belief that such disclosure is necessary to
          comply with a legal obligation or protect the rights and safety of our
          users or the public.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Within Our Group:</span> We may
          share your data internally with our group entities and affiliates to
          provide a seamless service experience.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Business Transfers:</span> In the
          event of a merger, acquisition, or sale of assets, your personal data
          may be transferred as part of that transaction. You will be notified
          of any such change as required under applicable law.
        </p>
        <p>
          We do not sell your personal data to any third party outside of the
          real estate service ecosystem described above.
        </p>
        {/* <p>
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>
            Cross-Border Data Transfers
          </span>{" "}
        </p> */}
        <h3 className="mb-3">Cross-Border Data Transfers</h3>
        <p>
          Where your personal data is transferred outside the UAE, such as to
          cloud service providers or technology platforms, we ensure such
          transfers comply with the UAE PDPL. This includes ensuring the
          recipient country provides adequate data protection or that
          appropriate contractual safeguards are in place.
        </p>
        {/* <p>
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>
            Real Estate Partner Responsibility
          </span>{" "}
        </p> */}
          <h3 className="mb-3"> Real Estate Partner Responsibility</h3>
        <p>
          Once your enquiry data is shared with a licensed real estate broker,
          developer, or agency, that party becomes independently responsible for
          the processing of your data in connection with their follow-up
          activities. Blaccdot is not responsible for the privacy practices of
          our real estate partners. We encourage you to request and review the
          privacy policy of any real estate professional who contacts you as a
          result of your enquiry on our Platform.
        </p>
        <p>
          If you wish to stop receiving communications from a specific real
          estate partner, you should contact that partner directly.
        </p>
        {/* <p>
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>
            Marketing Communications
          </span>{" "}
        </p> */}
          <h3 className="mb-3">  Marketing Communications</h3>
        <p>
          With your consent, we and our real estate partners may contact you via
          SMS, WhatsApp, telephone calls, and email with information about
          property listings, off-plan launches, market reports, and relevant
          real estate opportunities in the UAE.
        </p>
        <p>
          You may opt out of marketing communications from Blaccdot at any time
          by clicking the unsubscribe link in any email, replying STOP to any
          SMS, or writing to us at the contact details below. Please note that
          opting out of marketing communications will not affect service-related
          communications necessary to process your active enquiries.
        </p>
        <p>
          All marketing communications are conducted in compliance with UAE
          regulations, including the guidelines of the{" "}
          <span style={{ fontWeight: "bold" }}>
            Telecommunications and Digital Government Regulatory Authority
            (TDRA)
          </span>{" "}
          and the UAE National Do Not Call Registry.
        </p>
        {/* <p>
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>
            Security of Your Personal Data
          </span>{" "}
        </p> */}
          <h3 className="mb-3">Security of Your Personal Data</h3>
        <p>
          We implement reasonable and appropriate technical and organisational
          security measures to protect your personal data from unauthorised
          access, disclosure, alteration, loss, or misuse. These include secure
          servers, encrypted data transmission, access controls, and regular
          security reviews.
        </p>
        <p>
          No method of data transmission over the internet is entirely secure.
          By using the Platform, you acknowledge the inherent risks of online
          data transmission. You are responsible for maintaining the
          confidentiality of any account credentials and for notifying us
          immediately if you suspect any unauthorised access to your account or
          personal data.
        </p>
        {/* <p>
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>
            Data Retention and Deletion
          </span>{" "}
        </p> */}
         <h3 className="mb-3">Data Retention and Deletion</h3>
        <p>
          We retain your personal data for no longer than is necessary for the
          purposes for which it was collected, or as required under applicable
          UAE law. In the context of real estate lead generation, this typically
          means retaining your data for the duration of your active property
          search engagement and for a reasonable period thereafter, in case of
          follow-up enquiries or legal requirements.
        </p>
        <p>
          We may retain anonymised and aggregated data for analytical and market
          research purposes indefinitely.
        </p>
        <p>
          You may request deletion of your personal data by contacting our Data
          Privacy Officer at the details below. We will action your request
          subject to any overriding legal retention obligations. Please note
          that deletion of your data may result in the discontinuation of active
          real estate introductions being facilitated on your behalf.
        </p>
        {/* <p>
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>
            Your Rights Under UAE Law
          </span>{" "}
        </p> */}
          <h3 className="mb-3">Your Rights Under UAE Law</h3>
        <p>
          As a user in the UAE, you have the following rights under the Federal
          Decree-Law No. 45 of 2021:
        </p>
        <p>
          {" "}
          <span style={{ fontWeight: "bold" }}>Right of Access</span> — You may
          request a copy of the personal data we hold about you.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Right to Rectification</span> —
          You may request correction of inaccurate or incomplete data.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Right to Erasure</span> — You may
          request deletion of your personal data, subject to legal retention
          obligations.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Right to Restriction</span> — You
          may request that we limit processing of your data in certain
          circumstances.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Right to Data Portability</span>{" "}
          — You may request your data in a structured, machine-readable format
          where technically feasible.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Right to Object</span> — You may
          object to processing of your data for direct marketing or where
          processing is based on legitimate interests.
        </p>
        <p>
          <span style={{ fontWeight: "bold" }}>Right to Withdraw Consent</span>{" "}
          — Where processing is based on consent, you may withdraw it at any
          time without affecting the lawfulness of prior processing.
        </p>
        <p>
          To exercise any of these rights, contact our Data Privacy Officer
          using the details below. We will verify your identity and respond
          within the timeframe required under UAE law.
        </p>
        {/* <p>
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>
            Consent
          </span>{" "}
        </p> */}
          <h3 className="mb-3">Consent</h3>
        <p>
          By submitting an enquiry or providing your information on the
          Platform, you consent to the collection, use, storage, and sharing of
          your personal data with relevant real estate professionals in the UAE,
          as described in this Privacy Policy.
        </p>
        <p>
          You consent to being contacted by Blaccdot and its real estate
          partners via phone, SMS, WhatsApp, email, and other messaging channels
          for the purposes of responding to your property enquiry and providing
          relevant real estate information.
        </p>
        <p>
          You may withdraw your consent at any time by writing to our Data
          Privacy Officer with the subject line "Withdrawal of Consent for
          Processing Personal Data." Withdrawal of consent will not be
          retrospective and may result in the discontinuation of real estate
          introductions or services being facilitated on your behalf.
        </p>
        {/* <p>
          {" "}
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>
            Protection Against Fraud
          </span>{" "}
        </p> */}
          <h3 className="mb-3">Protection Against Fraud</h3>
        <p>
          Blaccdot will never request sensitive financial information such as
          passwords, full card numbers, or bank PINs through unsolicited calls,
          emails, or messages. If you receive any communication claiming to be
          from Blaccdot that requests such information, do not respond and
          report it immediately to the TDRA or the relevant UAE law enforcement
          authority.
        </p>
        {/* <p>
          {" "}
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>
            Children's Privacy
          </span>{" "}
        </p> */}
         <h3 className="mb-3">Children's Privacy</h3>
        <p>
          Our Platform and services are intended for individuals aged 18 and
          above. We do not knowingly collect personal data from minors. If you
          believe a minor has submitted personal data through our Platform,
          please contact us immediately and we will delete such information.
        </p>
        {/* <p>
          {" "}
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>
            Changes to This Privacy Policy
          </span>{" "}
        </p> */}
         <h3 className="mb-3">Changes to This Privacy Policy</h3>
        <p>
          We may update this Privacy Policy periodically to reflect changes in
          our services, practices, or applicable UAE laws. Significant changes
          will be communicated through the Platform or via the contact details
          associated with your account. Your continued use of the Platform after
          any update constitutes acceptance of the revised policy. We encourage
          you to review this page regularly.
        </p>
        {/* <p>
          {" "}
          <span style={{ fontWeight: "bold", fontSize: "larger" }}>
            Grievance and Data Privacy Officer
          </span>{" "}
        </p> */}
          <h3 className="mb-3">Grievance and Data Privacy Officer</h3>
        <p>
          For any questions, concerns, requests to exercise your data rights, or
          complaints regarding this Privacy Policy, please contact:
        </p>

        <ul>
          <li>
            <span style={{ fontWeight: "bold" }}>Organisation:</span> Blaccdot
          </li>
          <li>
            <span style={{ fontWeight: "bold" }}>Role:</span> Data Privacy
            Officer
          </li>
          <li>
            <span style={{ fontWeight: "bold" }}>Email:</span>{" "}
            support@blaccdot.ae
          </li>
          <li>
            <span style={{ fontWeight: "bold" }}>Phone:</span> +971521912022
          </li>
          <li>
            <span style={{ fontWeight: "bold" }}>Operating Hours:</span> Monday
            to Friday, 9:00 AM – 6:00 PM (GST, UAE Time)
          </li>
          <li>
            <span style={{ fontWeight: "bold" }}>Mailing Address: </span>
            {/* Rakez Business Zone, Al Nakheel Area, P.O.Box No.10055, Ras Al
            Khaimah, United Arab Emirates */}
               Dubai, UAE
          </li>
        </ul>
        <p>
          We will acknowledge your request promptly and respond within the
          timeframe required under the UAE PDPL.
        </p>
      </section>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
